import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useViewport } from '@chilecompra/react-kit'
import { Card, Typography } from '@chilecompra/react-kit/components'

import QuoteListPurchaseOrderTable from './QuoteListPurchaseOrder.table'
import QuoteListPurchaseOrderDisclaimer from './QuoteListPurchaseOrder.disclaimer'

import { useAuthorization } from '../../containers/AuthorizationProvider/AuthorizationProvider.hooks'

import { QUOTE_STATUSES_DICTIONARY } from '../../config/settings/constants'

import { Grid } from './QuoteListPurchaseOrder.styles'

/**
 * The Quote List Purchase Order's container.
 */
const QuoteListPurchaseOrderContainer = () => {
  const { size } = useViewport()
  const { isSeller } = useAuthorization()

  const { basicInfo, loading, purchaseOrderHistory } = useSelector(state => state.quoteBasicInformation)

  const showDisclaimerPurchaseOrderPrivate = useMemo(() => {
    return (
      (purchaseOrderHistory?.emitPurchaseOrders || []).length === 0 &&
      purchaseOrderHistory?.hiddenPurchaseOrder &&
      isSeller
    )
  }, [purchaseOrderHistory?.emitPurchaseOrders, purchaseOrderHistory?.hiddenPurchaseOrder, isSeller])

  const shouldShowPurchaseOrders = useMemo(() => {
    if (
      (!purchaseOrderHistory?.emitPurchaseOrders || purchaseOrderHistory?.emitPurchaseOrders?.length === 0) &&
      !isSeller
    )
      return false

    return [
      QUOTE_STATUSES_DICTIONARY.CLOSED,
      QUOTE_STATUSES_DICTIONARY['Proveedor seleccionado'],
      QUOTE_STATUSES_DICTIONARY.CANCELLED,
      QUOTE_STATUSES_DICTIONARY.DESERTED
    ].includes(basicInfo?.statusId)
  }, [basicInfo?.statusId, isSeller, purchaseOrderHistory?.emitPurchaseOrders])

  if (!shouldShowPurchaseOrders) return null

  return (
    <>
      <Grid container padding={size.isDownToTiny ? '8px 0 0' : '41px 0 0'}>
        <Grid item xs={12}>
          <Typography color="black1" fontSize="22px" fontWeight="bold" lineHeight="26px" variant="h3">
            Órdenes de compra emitidas
          </Typography>
        </Grid>
        <Grid container padding={size.isDownToTiny ? '8px 0' : '20px 0 0'}>
          <Grid item xs={12}>
            <Card enableBorder color="blank" margin="4px 0 0">
              {!showDisclaimerPurchaseOrderPrivate && (
                <QuoteListPurchaseOrderTable
                  purchaseOrders={purchaseOrderHistory?.emitPurchaseOrders}
                  loading={loading}
                />
              )}
              {showDisclaimerPurchaseOrderPrivate && <QuoteListPurchaseOrderDisclaimer />}
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default QuoteListPurchaseOrderContainer
